import { CSSProperties, FC } from "react";
import {
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

type Props = {
    onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
};

const iconStyle: CSSProperties = {
  fontSize: 18,
  cursor: "pointer",
};

const HistoryActions: FC<Props> = ({ onView, onEdit, onDelete }) => {
  
  return (
    <div className="flex flex-nowrap items-center gap-3">
      {/* VIEW */}
      <EyeOutlined
  style={{ ...iconStyle, color: "#1890ff" }}
  onClick={onView}
/>

      {/* EDIT */}
      <EditOutlined
        style={{ ...iconStyle, color: "#52c41a" }}
        onClick={onEdit}
      />

      {/* DELETE */}
      <DeleteOutlined
        style={{ ...iconStyle, color: "#ff4d4f" }}
        onClick={onDelete}
      />
    </div>
  );
};

export default HistoryActions;
